export default __webpack_public_path__ + "static/media/img_21.bf3ac504.jpg";